import { render } from "./lobby-avatar.vue?vue&type=template&id=12083ffa"
import script from "./lobby-avatar.vue?vue&type=script&lang=js"
export * from "./lobby-avatar.vue?vue&type=script&lang=js"

import "./lobby-avatar.vue?vue&type=style&index=0&id=12083ffa&lang=scss"
script.render = render

export default script